// extracted by mini-css-extract-plugin
export default {"prizeWrapper":"Prizes_prizeWrapper__YFxfG","amountWrapper":"Prizes_amountWrapper__x5slS","first":"Prizes_first__t6TcQ","second":"Prizes_second__3S9tV","third":"Prizes_third__bRupm"};